import { render, staticRenderFns } from "./questionsEditor.vue?vue&type=template&id=4faff231&scoped=true&lang=html&"
import script from "./questionsEditor.vue?vue&type=script&lang=js&"
export * from "./questionsEditor.vue?vue&type=script&lang=js&"
import style0 from "./questionsEditor.vue?vue&type=style&index=0&id=4faff231&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faff231",
  null
  
)

export default component.exports